export const CLIENT_REVIEW_TEXT_CLASS =
    "text-xs  sm:text-lg font-normal font-Poppins italic text-Heading_Black leading-5 text-center pl-2 pr-1.5 ";
